var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diy-card-catalogue__card-actions"},[_c('CardCatalogueCardActionsAdd',{attrs:{"card":_vm.card}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }